import { ScheduleEntryModel } from "./scheduler-entry.model";

export class SchedulerDayBirthdayModel {
    date: string;
    schedule: ScheduleEntryModel[];

    constructor() {
        this.date = new Date().toISOString().split('T')[0];
        this.schedule = [];
    }
}